import { RECOMMEND_TAG_TYPE, RECOMMEND_TAG_TYPE_TEXT } from './tagConstants';

/**
 *  추천 태그 페이지 이름
 */
export const RECOMMEND_TAG_PAGE_NAME = {
  RECOMMEND_TAG_LIST: '추천 태그 리스트',
  RECOMMEND_TAG_DETAIL: '추천 태그 상세',
  RECOMMEND_TAG_COPY: '추천 태그 복사',
  RECOMMEND_TAG_CREATE: '추천 태그 등록',
};

/**
 *  추천 태그 타입 SELECT 리스트
 */
export const RECOMMEND_TAG_TYPE_SELECT_LIST = [
  {
    id: RECOMMEND_TAG_TYPE.SEARCH_RECOMMEND,
    name: RECOMMEND_TAG_TYPE_TEXT[RECOMMEND_TAG_TYPE.SEARCH_RECOMMEND],
  },
];

/**
 *  추천 태그 메모 최대 글자 수
 */
export const MAXIMUM_NUMBER_OF_RECOMMEND_TAG_MEMO = 2000;

/**
 *  추천 태그 아이템 최소 개수
 */
export const MINIMUM_NUMBER_OF_RECOMMEND_TAG_ITEM_COUNT = 3;

/**
 *  추천 태그 아이템 최대 개수
 */
export const MAXIMUM_NUMBER_OF_RECOMMEND_TAG_ITEM_COUNT = 5;
